import * as THREE from 'three';

/**
 * Drive texture detail at grazing angles (roads, buildings, car GLBs) — matches GPU max anisotropy.
 */
export function applyMaxAnisotropyToObject(
  root: THREE.Object3D,
  renderer: THREE.WebGLRenderer,
): void {
  const cap = renderer.capabilities.getMaxAnisotropy();
  root.traverse((obj) => {
    const mesh = obj as THREE.Mesh;
    if (!mesh.isMesh) return;
    const mats = Array.isArray(mesh.material)
      ? mesh.material
      : [mesh.material];
    for (const mat of mats) {
      if (!mat) continue;
      if (
        mat instanceof THREE.MeshStandardMaterial ||
        mat instanceof THREE.MeshPhysicalMaterial
      ) {
        const keys = [
          'map',
          'normalMap',
          'roughnessMap',
          'metalnessMap',
          'aoMap',
          'emissiveMap',
          'bumpMap',
          'lightMap',
          'alphaMap',
        ] as const;
        for (const key of keys) {
          const t = mat[key];
          if (t && (t as THREE.Texture).isTexture) {
            (t as THREE.Texture).anisotropy = cap;
          }
        }
      }
    }
  });
}
